/**
 * Voluum flow API: weights on path landers, sublanders, and offers must be
 * strictly less than 1000 (Voluum error: "must be less than 1000").
 *
 * For Media Devoted | Created By Ciro Autiero
 */

export const VOLUUM_PATH_ITEM_WEIGHT_MAX = 999;
